import { createAction } from 'redux-act';

export const getQuestions = createAction('Set questions');
export const setQuestions = createAction('Set questions');
export const questionsReset = createAction('Reset questions');

export const sendAnswers = createAction('Send answers');
